import React, { useEffect, useState } from 'react';
import { governorateService } from '../services/api';
import styles from './ReportFiltersSection.module.css';

const PROTEST_TYPES = ['مظاهرة', 'إضراب', 'اعتصام', 'ليلة احتجاجية', 'عريضة', 'وقفة احتجاجية', 'مسيرة'];

export default function ReportFiltersSection({ filters, onChange, onNext }) {
    const [governorates, setGovernorates] = useState([]);

    useEffect(() => {
        governorateService.list().then((r) => setGovernorates(r.data)).catch(() => {});
    }, []);

    const toggleGovernorate = (id) => {
        const exists = filters.governorates.includes(id);
        onChange({
            ...filters,
            governorates: exists
                ? filters.governorates.filter((g) => g !== id)
                : [...filters.governorates, id],
        });
    };

    const toggleType = (type) => {
        const exists = filters.protest_type.includes(type);
        onChange({
            ...filters,
            protest_type: exists
                ? filters.protest_type.filter((t) => t !== type)
                : [...filters.protest_type, type],
        });
    };

    return (
        <div className={styles.section}>
            <h2 className={styles.title}>الفلاتر</h2>
            <p className={styles.desc}>اختر نطاق البيانات التي تريد تضمينها في التقرير</p>

            <div className={styles.grid}>
                <div className={styles.group}>
                    <label className={styles.label}>من تاريخ</label>
                    <input
                        type="date"
                        className={styles.input}
                        value={filters.from_date}
                        onChange={(e) => onChange({ ...filters, from_date: e.target.value })}
                    />
                </div>

                <div className={styles.group}>
                    <label className={styles.label}>إلى تاريخ</label>
                    <input
                        type="date"
                        className={styles.input}
                        value={filters.to_date}
                        onChange={(e) => onChange({ ...filters, to_date: e.target.value })}
                    />
                </div>

                <div className={styles.group}>
                    <label className={styles.label}>حالة الرصد</label>
                    <select
                        className={styles.input}
                        value={filters.verified === null ? 'all' : filters.verified ? 'yes' : 'no'}
                        onChange={(e) => {
                            const v = e.target.value;
                            onChange({ ...filters, verified: v === 'all' ? null : v === 'yes' });
                        }}
                    >
                        <option value="all">الكل</option>
                        <option value="yes">مرصود ميدانياً</option>
                        <option value="no">غير مرصود</option>
                    </select>
                </div>

                <div className={styles.group}>
                    <label className={styles.checkLabel}>
                        <input
                            type="checkbox"
                            checked={filters.with_sources}
                            onChange={(e) => onChange({ ...filters, with_sources: e.target.checked })}
                        />
                        <span>مع مصادر فقط</span>
                    </label>
                </div>
            </div>

            {governorates.length > 0 && (
                <div className={styles.group}>
                    <label className={styles.label}>
                        المحافظات
                        {filters.governorates.length > 0 && (
                            <span className={styles.badge}>{filters.governorates.length} محددة</span>
                        )}
                    </label>
                    <div className={styles.checkGrid}>
                        {governorates.map((g) => (
                            <label key={g.id} className={styles.checkItem}>
                                <input
                                    type="checkbox"
                                    checked={filters.governorates.includes(g.id)}
                                    onChange={() => toggleGovernorate(g.id)}
                                />
                                <span>{g.name}</span>
                            </label>
                        ))}
                    </div>
                </div>
            )}

            <div className={styles.group}>
                <label className={styles.label}>
                    نوع الاحتجاج
                    {filters.protest_type.length > 0 && (
                        <span className={styles.badge}>{filters.protest_type.length} محدد</span>
                    )}
                </label>
                <div className={styles.checkGrid}>
                    {PROTEST_TYPES.map((type) => (
                        <label key={type} className={styles.checkItem}>
                            <input
                                type="checkbox"
                                checked={filters.protest_type.includes(type)}
                                onChange={() => toggleType(type)}
                            />
                            <span>{type}</span>
                        </label>
                    ))}
                </div>
            </div>

            <div className={styles.actions}>
                <button className={styles.nextBtn} onClick={onNext}>
                    التالي ←
                </button>
            </div>
        </div>
    );
}
